import axios, { AxiosRequestConfig } from 'axios'
import { message } from 'ant-design-vue'
import 'ant-design-vue/es/modal/style/index'
import store from '@/store'
import { Modal } from 'ant-design-vue'
import { ApplicationConfigProvider } from '@/config/app-config'
import UserManager from '@/user/UserManager'

const Axios = axios.create({
  // API 请求的默认前缀
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 5 * 1000 * 60 // 请求超时时间
})

interface axiosError {
  response: any
}

const errorMsg = (content: any) => {
  Modal.warning({
    title: 'Error',
    content: content
  })
}

const errorHandler = (error: axiosError) => {
  if (error.response) {
    if (error.response.status === 401) {
      return UserManager.Login()
    }

    // errorMsg(`response.status: ${error.response.status}`);

    return error.response.data
  } else {
    errorMsg(`${error}`)
  }
}

// request interceptor
Axios.interceptors.request.use((config) => {
  const { url } = config

  if (url?.indexOf('://') === -1) {
    config.url = ApplicationConfigProvider.current.serviceEndpoint + url
  }

  const { user } = store.state
  if (user.access_token) {
    config.headers!.Authorization = 'Bearer ' + user.access_token
  }
  const clientUrl = typeof window !== 'undefined' ? window.location.href : '';
  config.headers = config.headers || {};
  config.headers['X-Client-Url'] = clientUrl;
  return config
}, errorHandler)

// response interceptor
Axios.interceptors.response.use((response) => {
  if (response.data.State && response.data.State !== 200 && !response.config.noError) {
    errorMsg(response.data.message || response.data.Message)
  }
  return response.data
}, errorHandler)

export const get = (
  url: string,
  params: Record<string, any> = {},
  config: Record<string, any> = {}
) => {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
      ...params,
      ...config
    })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => reject(error))
  })
}

export const post = (
  url: string,
  params: Record<string, any> | Array<any> = {},
  config: Record<string, any> = {}
) => {
  return new Promise((resolve, reject) => {
    Axios.post(
      url,
      Array.isArray(params)
        ? params
        : {
          ...params
        },
      config
    )
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  get,
  post,
  Axios
}
